import ArrowRightSvg from '@/assets/ArrowRightSvg.svg';
import PensiveRobotSvg from '@/assets/PensiveRobotSvg.svg';
import ButtonWithLoading from '@/components/ButtonWithLoading.comp.tsx';
import DialogDesktop from '@/components/dialog/DialogDesktop.tsx';
import { generateNonCachableImageSrc } from '@/utils/generateNonCachableImageSrc.util.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import React from 'react';

export interface ErrorsMessageProps {
  handleBack: (event: React.FormEvent) => void;
}

const ErrorsMessageDesktop: React.FC<ErrorsMessageProps> = ({ handleBack }) => {
  const { t } = useTranslationWithPrefix('views.errors');
  return (
    <div className="flex gap-20 mt-20">
      <div className="relative flex-1 flex flex-col justify-center items-center gap-14">
        <DialogDesktop
          arrow={
            <img
              alt="arrow-down"
              className="absolute -z-10 -right-11 bottom-1/4"
              src={ArrowRightSvg}
            />
          }
          message={t('basic.title')}
        />
        <ButtonWithLoading className="align-self-md-center" onClick={handleBack}>
          {t('buttons.back')}
        </ButtonWithLoading>
      </div>
      <div className="-mt-24">
        <img
          alt="love-robot"
          className="object-cover"
          src={generateNonCachableImageSrc(PensiveRobotSvg)}
        />
      </div>
    </div>
  );
};

export default ErrorsMessageDesktop;
